export const BUDGET_PATH = '/budget'

/** One envelope's detail. A sibling Route of the generated `/budget/*`, as `TRANSACTION_DETAIL_PATH` is of `/transactions/*`. */
export const BUDGET_DETAIL_PATH = '/budget/:id'

/** The id is encoded, so it can only ever fill the `:id` segment. */
export function budgetDetailPath(id: string): string {
  return `${BUDGET_PATH}/${encodeURIComponent(id)}`
}
